import {BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import {mc} from '@px/helper/mc';
import {numUtil} from '@px/helper/num';
import {investmentApi} from '@px/api/investment';

export const investmentProduct$ = new BehaviorSubject([]);
export const maxRate$ = new BehaviorSubject('-');

investmentProduct$.pipe(map(genMaxRate)).subscribe((rate) => maxRate$.next(rate));

export async function loadInvestmentProduct() {
  const {data, error} = await investmentApi.getProduct();
  if (data) {
    investmentProduct$.next(data.rows);
    return;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
}

function genMaxRate(rows) {
  const rateErs = rows.map((row) => row.rateEr);
  if (rateErs.length < 1) {
    return '--%';
  }
  const maxRateEr = Math.max(...rateErs);
  return numUtil.floor(maxRateEr, 2, 6) + '%';
}
